<template>
  <div :style="{'--themeColor': themeColor}" class="body" style="height:100%">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App',
  data () {
    return {
      themeColor: '#003965'
    }
  },
  async created () {
    if (!await this.hasMaintain(0)) {
      this.$router.push({ path: '/maintain' })
    }
  }
}
</script>

<style>
.body {
 --themeColor: var(--themeColor)
}
</style>



// WEBPACK FOOTER //
// src/App.vue